{
  "autoZoom": "Zoom automatique",
  "averageApplicationRateWithVal": "Taux d'application moyen : {{val}}",
  "averagePressureWithVal": "Pression moyenne : {{val}}",
  "averageSpeedWithVal": "Vitesse moyenne : {{val}}",
  "contrast": "Augmenter le contraste",
  "durationWithVal": "Durée : {{val}}",
  "linkTo": "Histoire de l'irrigation",
  "noReelRuns": "Aucune course n'a été enregistrée pendant la période sélectionnée. Ajustez la période ou revenez plus tard",
  "runsListTitle": "Bobines de tournage",
  "selectedRunTitleWithRunCount": "Exécutez {{selectedRunIndex}} sur {{runCount}}",
  "showBorders": "Afficher les contours",
  "startDateWithVal": "Date de début : {{val}}",
  "tabGraphs": "Graphiques",
  "tabRuns": "Courses",
  "title": "Histoire de l'irrigation",
  "totalApplicationWithVal": "Application totale : {{val}} acres-pouces.",
  "totalRunsWithItemCount": "Nombre total d'exécutions : {{itemCount}}",
  "applicationType": {
    "water": "Eau",
    "manure": "Lisier",
    "other": "Autre"
  },
  "applicationTypeWithVal": "Appliqué : {{val}}"
}
